const getCardsConfigs = () => {
  const cardsConfig = import(/* webpackMode: "eager" */'../webpack-helper-files/cards-config');
  return cardsConfig;
};

const getWelcomeCardsConfig = () => {
  const cardsConfig = import(/* webpackMode: "eager" */'../webpack-helper-files/welcome-card-config');
  return cardsConfig;
};

export function fetchDataForOverview(serverContext, preferenceService, resolve, reject) {
  if (serverContext.WelcomeStatus && serverContext.WelcomeStatus.ShowWelcomeTips) {
    import(/* webpackMode: 'eager' */'@bingads-webui-campaign-legacy/dashboard-page/dashboard/data-fetch-welcome').then(({ fetchWelcomeTipData }) => {
      fetchWelcomeTipData();
      resolve();
    });
  } else {
    import(/* webpackMode: 'eager' */'@bingads-webui-campaign-legacy/dashboard-page/dashboard/data-fetch-manager').then(({ fetchOverviewTilesData }) => {
      import(/* webpackMode: 'eager' */'@bingads-webui-campaign/filter-storage').then(({ WaterfallFilterStorage, WaterfallFilterType }) => {
        const waterfallFilterStorage = new WaterfallFilterStorage({
          preferenceService,
        });
        const filter = waterfallFilterStorage.getFilters([
          WaterfallFilterType.CampaignType,
          WaterfallFilterType.CampaignStatus,
          WaterfallFilterType.AdGroupStatus,
        ]);

        import(/* webpackMode: 'eager' */'@bingads-webui-campaign-react/shell-ui-common').then(({ getFilteredCampaignTypeFromWaterfallFilter }) => {
          const campaignType = getFilteredCampaignTypeFromWaterfallFilter(filter);

          import(/* webpackMode: 'eager' */'@bingads-webui-campaign/overview-panel').then(({ getViewportCardCount, DateFilterState, CardState }) => {
            Promise.all([getCardsConfigs(), getWelcomeCardsConfig()]).then((modules) => {
              fetchOverviewTilesData({
                filter,
                campaignType,
                resolve,
                reject,
                getViewportCardCount,
                DateFilterState,
                CardState,
                newCardsConfig: modules[0].getCardsConfig,
                welcomeCardsConfig: modules[1].welcomeCardConfig,
              });
            });
          });
        });
      });
    });
  }
}
